import { combineReducers } from 'redux';

import user from './user';
import todos from './todos';
import products from './products';
import orders from './orders';

const createRootReducer = routerReducer => combineReducers({
  router: routerReducer,
  user,
  todos,
  products,
  orders,
});

export default createRootReducer;
